<template>
<div class="wrap">
    <wedHd></wedHd>

<div class="wepTex">
    <div class="title">彩讯5G新消息平台</div>
    <div class="text">彩讯5G新消息平台是连接行业客户与底层消息中心，通过对内容、消息、任务的综合管理实现5G消息的场景化下发，助力行业客户实现消息场景升级。</div>
</div>

<div class="contentBox">
    <div class="titleBox">核心能力</div>
    <!-- <div>
        <van-grid :column-num="2">
        <van-grid-item v-for="value in 6" :key="value" icon="photo-o" text="文字"  @click='moses(value)'/>
        </van-grid>
    </div> -->

    <ul class="coreWrap">
        <li>
            <div class="comTex">
                <div class="title">行业场景模板库</div>
                <div class="texts">面向多个行业提供常用场景模板，行业内客户可快速调用，实现5G消息服务快速商用。</div>
            </div>
            <div class="conImg">
                <img src="@/assets/images/wap/list1.png" alt="">
            </div>
        </li>

        <li>
            <div class="comTex">
                <div class="title">行业chatbot</div>
                <div class="texts">面向垂直行业提供标准版chatbot解决方案，提供智能应答和知识库补充更新。</div>
            </div>
            <div class="conImg">
                <img src="@/assets/images/wap/list2.png" alt="">
            </div>
        </li>

                <li>
            <div class="comTex">
                <div class="title">消息有效触达率</div>
                <div class="texts">具备5G消息终端判断能力，并提供含短信、视频短信、chatbotH5等多种消息回落解决方案，保障消息有效触达率。</div>
            </div>
            <div class="conImg">
                <img src="@/assets/images/wap/list3.png" alt="">
            </div>
        </li>

                <li>
            <div class="comTex">
                <div class="title">标准5G消息平台</div>
                <div class="texts">可快速开通企业5G消息服务，通过平台实现从模板管理、场景配置、审核下发、数据统计的一站式便捷平台操作。</div>
            </div>
            <div class="conImg">
                <img src="@/assets/images/wap/list4.png" alt="">
            </div>
        </li>
    </ul>
</div>


<div class="contentBox contentList">
    <div class="titleBox">平台优势</div>

    <ul class="coreWrap">
        <li>
            <img src="@/assets/images/wap/item1.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item10.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item9.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item2.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item3.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item4.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item5.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item6.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item7.png" alt="">
        </li>
        <li>
            <img src="@/assets/images/wap/item8.png" alt="">
        </li>

    </ul>
</div>
 <div class="trialWrap">
     <div class="trialTile">申请试用 >></div>
     <div class="pBox">选择彩讯5G新消息平台，构建企业5G消息应用场景，助力行业客户实现消息场景化升级</div>
     <a class="btnBox" href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">
        <img src="@/assets/images/wap/btn.png" alt="">
     </a>
     
     <div class="text">即刻成为开发者，赋能企业服务客户能力，开启5G消息应用新时代。</div>
 </div>

 <wedFt></wedFt>
 <!-- <div class="footBtn">
     <img src="@/assets/images/wap/footLogo.png" alt="">
     <p>版权所有 © 彩讯科技股份有限公司.All right reserved</p>
     <p>粤ICP备15050890号-2</p>
 </div> -->
</div>
</template>

<script>
import wedHd from '@/components/wepHearder.vue'
import wedFt from '@/components/wefot.vue'
export default {
     components:{
        wedHd,
        wedFt
    },
    name: 'wapHome',
    data(){
        return{
            'photo-o':'@/assets/images/wap/banner1.png',
            show: false,
            // actions: [{ name: '选项一' }, { name: '选项二' }, { name: '选项三' }],
            popupShow:false
        }
    },
    methods:{
        moses(val){
            console.log(val)
        },
        onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      Toast(item.name);
    }
    }
}
</script>
<style scoped>
/* 底部黑色背景列表内容Start */
.footBtn{
    padding: 10px 20px;
    box-sizing: border-box;
    background: #2A2B2C;
}
.footBtn img{
    width: 100%;
    height: 43px;
    margin-bottom: 10px;
}
.footBtn p{
    color: #F4F5F6;
    line-height: 25px;
    font-size: 12px;
    
}
.van-cell::after{
    display: none;
}
.van-cell__right-icon{
    color: #fff;
}
.van-cell{
    background: none;
    color: #fff;
}
.van-cell--clickable:active{
    color: #1C2A39;
}
.navwrap{
    background: #2A2B2C;
    padding-top:10px;
    border-bottom: 1px solid #5C5D5E;
}
/* 底部黑色背景列表内容End */
/* 申请试用Start */
.btnBox{
    display: inline-block;
    padding: 10px 0;
    text-align: center;
}
.btnBox img{
    width: 100%;
    /* width: 9.34rem; */
    /* height: 1.99rem; */
}
.trialWrap{
    margin-top: 10px;
    background: #fff;
    height: 339px;
    padding: 20px;
    box-sizing: border-box;
    background: url(../../assets/images/wap/footBg.png) no-repeat left bottom;
    background-size: cover;
}
.trialWrap .trialTile{
    padding: 10px 0;
    color: #1C2A39;
    font-size: 0.64rem;
    font-weight: bold;
}
.trialWrap .pBox{
    font-size: 14px;
    color: #4D5865;
    padding: 10px 0;
    line-height: 25px;
}
.trialWrap .text{
    font-size: 14px;
    color: #fff;
    line-height: 25px;
    margin-top: 20px;
}
/* 申请试用End */
.contentList{

}
.contentList .coreWrap{
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
}
.contentList .coreWrap li{
    background-color: #fff;
    border:1px solid #EDEEF0;
    width: 50%;
    box-sizing: border-box;
    text-align: center;
    /* height: 276px; */
    line-height: 276px;
    padding: 0;
}
.contentList .coreWrap li img{
    width: 188px;
    height: 171px;
}
.coreWrap{
    background-color: #fff;
}
.coreWrap li{
    padding: 22px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.coreWrap li .comTex{
    flex: 1;
    margin-right: 20px;
}
.coreWrap li .comTex .title{
    color: #1C2A39;
    font-size: 16px;

}
.coreWrap li .comTex .texts{
    color: #4D5865;
    font-size: 13px;
    margin-top: 8px;
    line-height:22px;

}
.coreWrap li .conImg{
    width: 105px;
    height: 80px;
}
.coreWrap li .conImg img{
    width: 100%;
}
.wrap{
    background: #f4f5f6;
}
.vieHead{
    width: 100%;
    height: 50px;
    padding: 0 10px 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.swiperBox img{
    width: 100%;
    height: 100%;
}
.wapLogo{
    width: 136px;
    height: 36px;
}
.wapLogo img,.wapmore img{
    width: 100%;
}
.wapmore{
    width: 25px;
    height: 25px;
}
.my-swipe img {

}
.wepTex{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    /* margin: 35px 0; */
    /* margin-bottom: 10px; */
    background: #fff;
}
.wepTex .title{
    color: #1C2A39;
    font-size: 24px;
    padding: 20px 0;

}
.wepTex .text{
    color: #4D5865;
    font-size: 13px;
    line-height: 22px;

}
.contentBox{
    background: #fff;
    margin-top: 10px;
}
.titleBox{
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top;
    background-size:29px;
    padding-left: 15px;
    /* border-bottom: 1px solid #EDEEF0; */
}
</style>


// WEBPACK FOOTER //
// src/pages/wapHome/index.vue